export default () => [
  {
    field: "seq",
    width: 50,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "saveStatus",
    align: "center",
    width: 100,
    title: "导入状态",
    slots: { default: "status" },
  },
  {
    field: 'errorMsg',
    align: 'center',
    headerAlign: 'center',
    title: '导入异常原因',
    width: 200,
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: "driverName",
    width: 100,
    align: "center",
    title: "司机姓名",
  },
  {
    field: 'driverMobile',
    title: '司机手机号',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'driverID',
    align: 'center',
    minWidth: 220,
    title: '司机身份证号',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'driverOwnerTypeName',
    align: 'center',
    minWidth: 120,
    title: '司机归属',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'orgName',
    align: 'left',
    minWidth: 200,
    title: '登记机构',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'driverLicenseTypeName',
    align: 'center',
    minWidth: 100,
    title: '驾照类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'driverLicense',
    align: 'center',
    minWidth: 120,
    title: '驾驶证号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'carrierName',
    align: 'center',
    minWidth: 200,
    title: '所属承运商(简称)',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'driverRemarks',
    align: 'center',
    minWidth: 120,
    title: '备注',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
];
